import http from "../http-common";

export const putManageTableVisibility = (storageKey, visibilityMap) => {
  return http.put("/user-perf/manage-table", { storageKey, visibilityMap });
};
